// extracted by mini-css-extract-plugin
export default {"container":"GlobalErrorBoundary_container__Rmvak"};